module.exports = __webpack_public_path__ + "static/fonts/iconfont.b7a714ad.woff";